import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";

interface UseApproveAnpReportProps {
  id?: string;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useApproveAnpReport = ({ id, onSuccess, onError }: UseApproveAnpReportProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['approveAnpReport', id],
    mutationFn: () => privateAxios.post(`/anp/reports/${id}/approve`),
    onSuccess,
    onError,
  });
};
